import { Alert, Button, Container, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { CastAyudanteInvestigacionToSolicitudAyudanteInv, setSolicitudAyudanteInv, SolicitudAyudanteInv, voidSolicitudAyudanteInv } from "../../interfaces/ayudantias/SolicitudAyudanteInv";
import { SolicitudAyudanteValidate } from "../ValidationForm/validationAyudanteInvForm";
import { EstudianteActivoDTO } from "../../interfaces/SAAC/EstudianteActivoDTO";
import { PeriodoAcademicoDTO, VoidPeriodoAcademicoDTO } from "../../interfaces/SAAC/PeriodoAcademicoDTO";
import { useNavigate } from "react-router-dom";
import ItinerarioService from "../../services/ItinerarioService";
import AcademicoService from "../../services/AcademicoService";
import { CatalogoProfesor } from "../../interfaces/SAAC/CatalogoProfesor";
import { AyudantiaInvestigacion, CastSolicitudAyudanteInvToAyudantiaInvestigacion } from "../../interfaces/ayudantias/AyudantiaInvestigacion";
import AyudantiaService from "../../services/AyudantiaService";
import AlertService from "../../services/AlertService";

const alertService = new AlertService();
const academicoService = new AcademicoService();
const ayudantias = new AyudantiaService();

interface Props {
    estudiante: EstudianteActivoDTO;
    idProyecto: number;
    ayudantia: AyudantiaInvestigacion;
    token: any,
    onResponse?: (dataRespuesta: any) => void // Función para pasar la respuesta al padre
}

export const SolicitudAyudantesInvForm: React.FC<Props> = ({ estudiante, token, ayudantia, idProyecto, onResponse }) => {
    const navigate = useNavigate();
    const [periodoActivo, setPeriodoActivo] = useState<PeriodoAcademicoDTO>(VoidPeriodoAcademicoDTO());
    const [docentes, setDocentes] = useState<Array<CatalogoProfesor>>([]);
    const [mensajes, setMensajes] = useState<Array<string>>([]);

    const GetPeriodo = async () => {
        await academicoService.GetPeriodoAcademicoEnEjecucion(token)
            .then((data) => {
                setPeriodoActivo(data.data)
                GetDocentes(data.data.idperiodo)
            })
            .catch((error) => console.error(error));
    };

    const GetDocentes = async (idperiodo: number) => {
        await academicoService.GetCatalogoProfesores(token, idperiodo, idProyecto, 'A')
            .then((data) => {
                //console.log(data.listData);
                setDocentes(data.listData);
            })
            .catch((error) => console.error(error));
    };

    const formik = useFormik<SolicitudAyudanteInv>({
        initialValues: ayudantia.proyectoAyud.iddecinvproyectoayud > 0 ? CastAyudanteInvestigacionToSolicitudAyudanteInv(ayudantia) : voidSolicitudAyudanteInv(),
        validationSchema: SolicitudAyudanteValidate,
        onSubmit: (values) => {
            var obj = setSolicitudAyudanteInv(values);
            //console.log(obj);
            if(obj.idsolicitud === 0){
                GuardarSolicitudIAyudante(obj);
            }else{
                ActualizarSolicitudIAyudante(obj);
            }            
        }
    });

    const GuardarSolicitudIAyudante = async (values: SolicitudAyudanteInv) => {
        let obj = CastSolicitudAyudanteInvToAyudantiaInvestigacion(ayudantia,values, periodoActivo, idProyecto, estudiante);
        console.log(obj);
        alertService.showLoading("Espere...");
        setMensajes([]);
        await ayudantias.PostSolicitudAyudantiaInvById(token, obj)
            .then((data) => {
                if (data.status.isSuccessfully) {
                    if (onResponse) {
                        onResponse(data.data);
                    } else {
                        console.error('La función onResponse no está definida.');
                    }
                    alertService.hideLoading();
                    alertService.alertaExito('Éxito', 'Solicitud registrada.');
                } else {
                    setMensajes(data.status.messages);
                    alertService.hideLoading();
                    alertService.alertaAdvertenciaList('Alerta', data.status.messages);
                }
            })
            .catch((error) => console.error(error));
    }
    const ActualizarSolicitudIAyudante = async (values: SolicitudAyudanteInv) => {
        let obj = CastSolicitudAyudanteInvToAyudantiaInvestigacion(ayudantia,values, periodoActivo, idProyecto, estudiante);
        console.log(obj);
        alertService.showLoading("Espere...");
        setMensajes([]);
        await ayudantias.UpdateSolicitudAyudantiaInvById(token, obj)
            .then((data) => {
                if (data.status.isSuccessfully) {
                    if (onResponse) {
                        onResponse(data.data);
                    } else {
                        console.error('La función onResponse no está definida.');
                    }
                    alertService.hideLoading();
                    alertService.alertaExito('Éxito', 'Solicitud registrada.');
                } else {
                    setMensajes(data.status.messages);
                    alertService.hideLoading();
                    alertService.alertaAdvertenciaList('Alerta', data.status.messages);
                }
            })
            .catch((error) => console.error(error));
    }
    useEffect(() => {
        GetPeriodo()
    }, [estudiante]);
    return (
        <Container maxWidth="lg" style={{ border: '1px solid #517ED3', borderRadius: '5px', padding: '20px', borderTopWidth: '3px', textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: '#517ED3' }}>
                Detalle de la Solicitud
            </Typography>
            <form onSubmit={formik.handleSubmit}>
                <Grid container direction={'row'} spacing={1}>
                    <Grid item xs={12} sm={12} md={12}>
                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.descripcion && formik.touched.descripcion)}>
                            <TextField
                                fullWidth
                                id="descripcion"
                                name="descripcion"
                                label="Descripción de la necesidad"
                                value={formik.values.descripcion}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.descripcion && Boolean(formik.errors.descripcion)}
                                multiline
                                sx={{ marginBottom: '20px', width: '100%' }}
                            />
                            {formik.touched.descripcion && formik.errors.descripcion && (
                                <Alert severity="error">{formik.errors.descripcion}</Alert>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.horas && formik.touched.horas)} >
                            <InputLabel htmlFor="select-horas">Horas</InputLabel>
                            <Select
                                labelId="select-horas"
                                name="horas"
                                label='Horas'
                                variant="outlined"
                                value={formik.values.horas}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                sx={{ marginBottom: '20px', width: '100%' }}
                            >
                                <MenuItem value={''}>SELECCIONE HORAS</MenuItem>
                                <MenuItem value={'5'}>5</MenuItem>
                                <MenuItem value={'10'}>10</MenuItem>
                            </Select>
                            {formik.touched.horas && formik.errors.horas && (
                                <Alert severity="error">{formik.errors.horas}</Alert>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.termino && formik.touched.termino)} >
                            <TextField
                                fullWidth
                                id="termino"
                                name="termino"
                                label="Término"
                                type="text"
                                value={periodoActivo.termino+"-"+periodoActivo.anio}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.termino && Boolean(formik.errors.termino)}
                                sx={{ marginBottom: '20px', width: '100%' }} // Ajuste del ancho del TextField
                                disabled
                            />
                            {formik.touched.termino && formik.errors.termino && (
                                <Alert severity="error">{formik.errors.termino}</Alert>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.actividades && formik.touched.actividades)}>
                            <TextField
                                fullWidth
                                id="actividades"
                                name="actividades"
                                label="Actividades a realizar"
                                value={formik.values.actividades}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.actividades && Boolean(formik.errors.actividades)}
                                multiline
                                sx={{ marginBottom: '20px', width: '100%' }}
                            />
                            {formik.touched.actividades && formik.errors.actividades && (
                                <Alert severity="error">{formik.errors.actividades}</Alert>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.docente && formik.touched.docente)} >
                            <InputLabel htmlFor="select-docentes">Responsable de la ayudantía</InputLabel>
                            <Select
                                labelId="select-docentes"
                                name="docente"
                                label='Responsable de la ayudantía'
                                variant="outlined"
                                value={formik.values.docente}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                sx={{ marginBottom: '20px', width: '100%' }}
                            >
                                {docentes.length > 0 ? (
                                    docentes.map((materia) => (
                                        <MenuItem key={materia.email} value={materia.email}>
                                            {materia.label}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem value="">Seleccione un docente</MenuItem>
                                )}
                            </Select>
                            {formik.touched.docente && formik.errors.docente && (
                                <Alert severity="error">{formik.errors.docente}</Alert>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl
                            component="fieldset"
                            error={Boolean(formik.errors.tipofinanciamiento && formik.touched.tipofinanciamiento)}
                        >
                            <FormLabel component="legend">Tipo de financiamiento de la ayudantía</FormLabel>
                            <RadioGroup
                                aria-label="tipofinanciamiento"
                                name="tipofinanciamiento"  // El nombre debe coincidir con el campo de Formik
                                value={formik.values.tipofinanciamiento}  // El valor proviene de Formik
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}  // Marca el campo como tocado al perder el foco
                            >
                                <FormControlLabel value="0" control={<Radio />} label="Cupos de apoyo/ESPOL" />
                                <FormControlLabel value="1" control={<Radio />} label="Fondos Proyectos" />
                                <FormControlLabel value="2" control={<Radio />} label="Ad Honorem (Sin Pago al ayudante)" />
                            </RadioGroup>

                            {formik.touched.tipofinanciamiento && formik.errors.tipofinanciamiento && (
                                <Alert severity="error">{formik.errors.tipofinanciamiento}</Alert>
                            )}
                        </FormControl>
                    </Grid>


                    <Grid item xs={12} sm={12} md={12}>
                        <Button style={{ backgroundColor: '#517ED3', color: 'white', width: '50%', borderRadius: '25px' }} variant="contained" type="submit">
                            GUARDAR
                        </Button>
                    </Grid>
                </Grid>

            </form>
            <br />
            {mensajes.map((mensaje, i) => (
                        <div key={"mensajeError-"+i} style={{ color: 'red' }}>
                            <strong>{i+1}.</strong> {mensaje}
                        </div>
            ))}
        </Container>
    );
};